import { z } from 'zod';
import { defineExtension } from '../../lib/extension';
import { DEFAULT_SITE, SITE_KEYS } from '../../lib/vc';

export const meta = defineExtension({
  id: 'deeplink-generator',
  title: 'Deeplink generator',
  description: 'Generates the app deeplink for the page URL held in a sibling field and stores it in this field.',
  owner: '@eric-margerit_vco',
  location: 'custom_field',
  dataType: 'text',
  config: z.object({
    /** Which Vestiaire site the deeplink is generated for. */
    site: z.enum(SITE_KEYS).default(DEFAULT_SITE),
    /** uid of the sibling field that holds the web page URL. */
    pageUrlField: z.string().min(1).default('url'),
  }),
});
